<template>
    <div class="sport" :class="[{active: elementIsActive},{default: !elementIsActive}, element.color]" @click="changeFilter()">{{ element.ru }}</div>
</template>
<script>
export default {
    name: 'ElementSport',
    data: () => {
      return {
        active: false
      }
    },
    props: {
        element: {
            type: Object,
            required: true
        }
    },
    computed: {
      elementIsActive () {
        let actives = this.$store.getters.getActiveSportsNew;
        return actives ? actives.find(element => element.id === this.element.id) : false
      }
    },
    methods: {
      changeFilter () {
        this.active = !this.active;
        this.element.active = !this.element.active;
        this.$store.dispatch('changeSportsNew', this.element)
      }
    }
}
</script>